<template>
  <div class="my_form">
    <el-form class="form" :model="form" ref="ruleForm" inline>
      <el-row>
        <el-col :span="8">
          <el-form-item label="工程名称:" prop="projectName">
            <el-input v-model="form.projectName"/>
          </el-form-item>
        </el-col>
        <el-col :span="6" class="action">
            <el-button size="small" type="primary" @click="submitForm" plain>查询</el-button>
            <el-button size="small" @click="resetForm">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
    <STable :columns="columns" :loadData="loadData" ref="table">
      <template #sn='{ $index }'>
        {{ $index + 1 }}
      </template> 
    </STable>
  </div>
</template>

<script>
import { LicenseManagement } from '@/api/Licence'
import STable from '@/components/STable'
export default {
  components: {
    STable
  },
  data () {
    return {
      form: {
        projectName: ''
      },
      columns: [
        {
          label: '序号',
          scopedSlots: 'sn',
          width: 100
        },
        {
          label: '项目名称',
          prop: 'projectName',
          ellipsis: true
        },
        {
          label: '证照类型',
          prop: 'licenseType',
          ellipsis: true,
          width: 200
        },
        {
          label: '证照编号',
          prop: 'licenseNo',
          width: 300,
          ellipsis: true
        },
        {
          label: '证照名称',
          prop: 'licenseName',
          width: 350,
          ellipsis: true
        },
        {
          label: '状态',
          prop: 'status',
          width: 150,
          ellipsis: true
        }
      ],
      loadData: (pageParam) => {
        return LicenseManagement.getProjectLicense(this, {
          oaFormProjectInfoDto:{
            projectName:this.form.projectName
          },
          pageParam
        }).then(rs => rs)
      },
    }
  },
  created () {
  },
  methods: {
    submitForm () {
      if (this.$refs.table) this.$refs.table.refresh(true)
    },
    resetForm () {
      this.form = {
        projectName: ''
      }
      this.submitForm()
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
